import moment from 'moment';
import * as fns from 'date-fns';
import { dateFormatRegionMap } from '../../constants/dateFormat';

const titleCallback =
    ({ format = 'MM/dd/yyyy' }) =>
    context => {
        const rawValue = context[0].label;
        const date = fns.parseISO(rawValue);
        return fns.isValid(date) ? moment(rawValue).format(format) : rawValue;
    };

const axisCallback =
    ({ labels, format = 'MMM dd' }) =>
    (_, index) => {
        if (!labels) return null;
        const value = labels[index];
        const date = fns.parseISO(value);
        return fns.isValid(date) ? moment(value).format(format) : value;
    };

const dateConfig = ({ labels, locale }) => {
    const dateRegion =
        locale || localStorage.getItem('mvc-date-locale') || 'en-US';

    const format = dateFormatRegionMap[dateRegion];
    return {
        scales: {
            x: {
                ticks: {
                    callback: axisCallback({
                        labels,
                        format: format.moment.axis,
                    }),
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    title: titleCallback({
                        format: format.moment.short,
                    }),
                },
            },
        },
    };
};

export default dateConfig;
